import { Box } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function TrackingEU() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const mailNoList = params.get("mailNoList");

  return (
    <Box height="100vh">
      <iframe
        src={`https://track.cainiao.com/orderTrack?mailNoList=${mailNoList}`}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="Example Page"
      />
    </Box>
  );
}
